import "assets/css/App.css";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import AuthLayout from "layouts/auth";
import AdminLayout from "layouts/admin";
import {
  ChakraProvider,
  Alert,
  AlertIcon,
  AlertTitle,
  Flex,
} from "@chakra-ui/react";
import theme from "theme/theme";
import { ThemeEditorProvider } from "@hypertheme-editor/chakra-ui";
import { AuthProvider, AuthContext } from "contexts/requiredAuth";
import React, { useContext } from "react";
import ReactDOM from "react-dom";
var pjson = require("../package.json");
import { ToastContainer } from "react-toastify";

const AppRoutes = () => {
  const Private = ({ children }) => {
    localStorage.setItem("_version", pjson.version);
    const { authenticated, loading } = useContext(AuthContext);

    if (loading) {
      return (
        <Flex mt="36vh">
          <Alert
            status="success"
            variant="subtle"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            height="200px"
          >
            <AlertIcon boxSize="40px" mr={0} />
            <AlertTitle mt={4} mb={1} fontSize="lg">
              carregando...
            </AlertTitle>
          </Alert>
        </Flex>
      );
    }

    if (!authenticated) {
      return <Redirect from="/" to="/auth/sign-in" />;
    }

    return children;
  };

  return (
    <AuthProvider>
      <HashRouter>
        <Switch>
          <Route path={`/auth`}>
            <AuthLayout />
          </Route>
          <Route path={`/admin`}>
            <Private>
              <AdminLayout />
            </Private>
          </Route>
          <Redirect from="/" to="/admin/dashboard" />
        </Switch>
      </HashRouter>
    </AuthProvider>
  );
};

document.querySelector('link[rel="icon"]').href = window.config.favicon;
document.querySelector('meta[name="theme-color"]').content =
  window.config.theme_color;

const el = document.getElementById("root");

//NÃO TROCAR
ReactDOM.render(
  <ChakraProvider theme={theme}>
    <ToastContainer />
    <React.StrictMode>
      <ThemeEditorProvider>
        <AppRoutes />
      </ThemeEditorProvider>
    </React.StrictMode>
  </ChakraProvider>,
  el
);
